import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=17df116a&scoped=true"
import script from "./baseInfo.vue?vue&type=script&lang=js"
export * from "./baseInfo.vue?vue&type=script&lang=js"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=17df116a&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df116a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17df116a')) {
      api.createRecord('17df116a', component.options)
    } else {
      api.reload('17df116a', component.options)
    }
    module.hot.accept("./baseInfo.vue?vue&type=template&id=17df116a&scoped=true", function () {
      api.rerender('17df116a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/khgjgpt/components/baseInfo.vue"
export default component.exports